import React from 'react';
import clsx from 'clsx';
import { Table } from 'semantic-ui-react';
import CollectionsLabelGroup from '@/collections/components/CollectionsLabelGroup';

const DatasetCollectionsCell = ({ collections, className }) => (
  <Table.Cell className={clsx('aridhia-dataset-collections-cell', className)}>
    <CollectionsLabelGroup collections={collections} showLogo={false} />
  </Table.Cell>
);

export default DatasetCollectionsCell;
